module.exports = __webpack_public_path__ + "efa2e2fcea8e631e9eb9395e195ef67e.svg";